import { Injectable } from "@angular/core";
import { BaseDataService, HttpService } from "./base.service";
import { Person } from "./../../resources";

export interface PeopleFilters {
  pageSize?: number;
  pageIndex?: number;
  search?: string;
  memberType?: number;
}

@Injectable()
export class PeopleService extends BaseDataService<Person> {
  constructor(http: HttpService) {
    super(http, "people");
  }

  createInstance(options: any): Person {
    return new Person(options);
  }

  filterBy(filters: PeopleFilters) {
    console.log(filters);
    return this.all(filters);
  }
}
